// extracted by mini-css-extract-plugin
export default {"warning":"Warning_warning__IRYT1","icon":"Warning_icon__39oE5","text":"Warning_text__LbjQU"};